// Description body. Rendered as Markdown on the recipe page.
// A "Preview" checkbox swaps the textarea for the rendered Markdown so the
// author can check formatting without leaving the form.
import { useState } from "react";
import { Form } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

type DescriptionInputProp = {
  value: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
};

const BodyInput = ({ value, setDescription }: DescriptionInputProp) => {
  const [preview, setPreview] = useState<boolean>(false);

  return (
    <div>
      <div className="d-flex align-items-center gap-3 mb-2">
        <Form.Check
          type="checkbox"
          id="description-preview"
          label="Preview"
          checked={preview}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPreview(e.target.checked)}
        />
        <a
          href="https://www.markdownguide.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="small"
          title="Opens the Markdown Guide in a new tab"
        >
          Markdown help
        </a>
      </div>
      {/* The textarea stays mounted while hidden so its value survives toggling
          and the form still submits it. `required` is dropped while hidden,
          otherwise the browser refuses to submit with a non-focusable invalid field. */}
      <Form.Control
        as="textarea"
        name="description"
        rows={12}
        placeholder="Description (Markdown supported)"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
        required={!preview}
        hidden={preview}
      ></Form.Control>
      {preview && (
        <div
          className="border rounded p-3 recipe-markdown"
          data-testid="description-preview"
          style={{ minHeight: "calc(12 * 1.5em + 0.75rem)" }}
        >
          {value.trim() ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{value}</ReactMarkdown>
          ) : (
            <span className="text-muted">Nothing to preview yet.</span>
          )}
        </div>
      )}
    </div>
  );
};

export default BodyInput;
